import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { FlowAiAssistant } from './FlowAiAssistant';

export const FlowAiAssistantBridge = react2angular(FlowAiAssistant, [
  'flowId',
  'stepId',
  'isStepWaitingForYou',
  'isStepCompleted'
]);
